import React, { useEffect, useRef, useState } from "react";
import { FoField, FoTable } from "./financeUi";
import { loadVendors, useFinanceToken } from "./osClient";

export function useOsResource(fetcher, deps) {
  const token = useFinanceToken();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tick, setTick] = useState(0);
  const fetcherRef = useRef(fetcher);
  fetcherRef.current = fetcher;

  useEffect(() => {
    if (!token) return undefined;
    let live = true;
    setLoading(true);
    fetcherRef.current(token)
      .then((next) => {
        if (live) setData(next);
      })
      .catch(() => {
        if (live) setData(null);
      })
      .finally(() => {
        if (live) setLoading(false);
      });
    return () => {
      live = false;
    };
    // fetcher is read from a ref so pages can pass a fresh closure.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, tick, ...deps]);

  return { token, data, loading, reload: () => setTick((value) => value + 1) };
}

export function useVendorOptions() {
  const token = useFinanceToken();
  const [vendors, setVendors] = useState([]);
  useEffect(() => {
    if (!token) return;
    loadVendors(token).then(setVendors);
  }, [token]);
  return vendors;
}

export const vendorName = (vendor) => vendor?.brandName || vendor?.name || "Brand";

export function VendorSelect({ vendors, value, onChange, label = "Brand", allowEmpty = true, emptyLabel = "Select a brand" }) {
  return (
    <FoField label={label}>
      <select className="fo-control" value={value || ""} onChange={(event) => onChange(event.target.value)}>
        {allowEmpty && <option value="">{emptyLabel}</option>}
        {(vendors || []).map((vendor) => (
          <option key={vendor._id} value={vendor._id}>{vendorName(vendor)}</option>
        ))}
      </select>
    </FoField>
  );
}

export function TextField({ label, value, onChange, type = "text", hint, required }) {
  return (
    <FoField label={label} hint={hint}>
      <input className="fo-control" type={type} value={value} required={required} onChange={(event) => onChange(event.target.value)} />
    </FoField>
  );
}

export function SelectField({ label, value, onChange, options, allowEmpty, emptyLabel = "Any" }) {
  return (
    <FoField label={label}>
      <select className="fo-control" value={value || ""} onChange={(event) => onChange(event.target.value)}>
        {allowEmpty && <option value="">{emptyLabel}</option>}
        {options.map((option) => {
          const key = typeof option === "string" ? option : option.value;
          const text = typeof option === "string" ? option : option.label;
          return <option key={key} value={key}>{text}</option>;
        })}
      </select>
    </FoField>
  );
}

export function PagerTable({ page, total, limit, onChange, ...props }) {
  return (
    <FoTable
      {...props}
      pagination={{
        current: page,
        pageSize: limit,
        total,
        onChange,
      }}
    />
  );
}
